import { useSelector } from 'react-redux';

import { useGetVideoIntelligenceStatus } from '~/components/AssetModal/shared/hooks/useGetVideoIntelligence';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { centralizedClipAssetIdSelector, centralizedClipIdSelector } from '~/store/centralizedClip/selectors';
import { useCanViewPrivateAddOn } from '~/swr-hooks/workspaces/addOns/useCanViewPrivateAddOn';

import { useAssetVersionChaptersList } from './useAssetVersionChaptersList';

export const useClipChapters = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const clipId = useSelector(centralizedClipIdSelector);
  const assetId = useSelector(centralizedClipAssetIdSelector);
  const workspaceId = currentWorkspace?.id;

  const { canViewAddOn: videoIntelligenceAddOnVisible } = useCanViewPrivateAddOn({ key: 'videoIntelligence' });

  const {
    data: videoIntelligenceStatus,
    isError: isVideoIntelligenceError,
    isLoading: isVideoIntelligenceLoading,
  } = useGetVideoIntelligenceStatus();

  const isVideoIntelligenceComplete = videoIntelligenceStatus?.status === 'complete';
  const isChaptersComplete = videoIntelligenceStatus?.statuses?.chapters === 'complete';

  const shouldFetchChapters = videoIntelligenceAddOnVisible && isChaptersComplete;
  const {
    data: chapters,
    isLoading: isChaptersLoading,
    isError: isChaptersError,
  } = useAssetVersionChaptersList(
    {
      workspaceId,
      assetId,
      clipId,
    },
    {
      enabled: shouldFetchChapters,
    },
  );

  const isLoading = isVideoIntelligenceLoading || isChaptersLoading;

  return {
    videoIntelligenceAddOnVisible,
    videoIntelligenceStatus,
    isVideoIntelligenceComplete,
    isChaptersComplete,
    isLoading,
    isVideoIntelligenceLoading,
    isChaptersLoading,
    isVideoIntelligenceError,
    isChaptersError,
    chapters,
  };
};
